function hasStages(value: readonly unknown[]): boolean {
	return value.length > 0;
}

export default hasStages;
